export default {
    moves: 'Drag',
    time: 'Tid',
    score: 'Poäng',
    settings: 'Inställningar',
    sounds: 'Ljud',
    autocomplete: 'Avsluta automatiskt',
    leftHanded: 'Vänsterhänt',
    newDeal: 'Ny giv',
    design: 'Anpassa',
    easy: 'Lätt',
    medium: 'Medel',
    hard: 'Svår',
    expert: 'Expert',
    master: 'Mästare',
    random: 'Slumpmässigt',
    balanced: 'Balans',
    rulesKlondikeURL: 'https://solitaires.com/se/articles/how-to-play-solitaire/',
    cardHighlight: 'Kortmarkering',
    rulesSpiderURL: 'https://solitaires.com/se/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/se/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Spela automatiskt',
    noMagicNeeded: 'Inget Trollspö behövs — fortsätt spelet på egen hand!',
    leaveFeedback: 'Lämna din feedback',
    feedbackThankYou: 'Vi uppskattar verkligen dina åsikter!',
    feedbackError: 'Ett fel inträffade. Ditt meddelande skickades inte.',
    thanksSubscribing: 'Tack för att du prenumererar!',
    rulesPyramidURL: 'https://solitaires.com/se/articles/how-to-play-pyramid-solitaire/',


    tutorialSkip: 'Hoppa över',
    tutorialRestart: 'Starta om',

    klondikeTutorialStep1: 'Målet är att flytta alla kort till grundhögarna genom att bygga varje färg i stigande ordning från ess till kung – som <span style="color: #F11F1F;">A♥, 2♥, 3♥</span> och så vidare. Tryck på ett kort för att skicka det dit!',
    klondikeTutorialStep2: 'Bra jobbat! Fortsätt bygga sekvenser i grundhögarna.',
    klondikeTutorialStep3: 'Snyggt! Du kan flytta kort mellan kolumner – placera ett kort på ett som är ett steg högre och har motsatt färg.',
    klondikeTutorialStep4: 'Du kan flytta en sekvens om det nedersta kortet är ett steg lägre och i en annan färg än det du lägger det på.',
    klondikeTutorialStep5: 'Om det finns en tom kolumn på bordet får du bara placera en kung eller en sekvens som börjar med en kung där.',
    klondikeTutorialStep6: 'Om du får slut på drag, tryck på högen för att vända nya kort. Du kan placera dem på bordet eller i grundhögarna.',
    klondikeTutorialStep7: 'Bra! Nu är det din tur att spela själv.',
    klondikeTutorialStep8: 'Om kortleken tar slut, tryck för att uppdatera och fortsätta spela.',
    klondikeTutorialStep9: 'Du är nästan klar! Fyll grundhögarna för att vinna spelet.',

    spiderTutorialStep1: 'Ditt mål är att flytta alla kort till grundhögarna genom att bilda fallande sekvenser från kung till ess på spelplanen. Tryck på ett kort för att börja bygga en sekvens!',
    spiderTutorialStep2: 'Du kan flytta en sekvens om det nedersta kortet är ett steg lägre än det du placerar det på. Tryck på det för att flytta hela högen!',
    spiderTutorialStep3: 'Bra jobbat! Fortsätt bygga sekvensen – när den är klar flyttas den automatiskt till grundhögen.',
    spiderTutorialStep4: 'Om du får slut på drag, tryck på kortleken för att dela ut nya kort – ett till varje kolumn.',
    spiderTutorialStep5: 'Snyggt jobbat! Nu är det din tur – avsluta spelet!',

    freeCellTutorialStep1: 'Ditt mål är att flytta alla kort till grundhögarna genom att bygga varje färg i stigande ordning från ess till kung – som A♠, 2♠, 3♠ och så vidare. Tryck på ett kort för att skicka det dit!',
    freeCellTutorialStep2: 'Du kan flytta kort mellan kolumnerna på spelplanen – placera ett kort på ett som är ett steg högre och i en annan färg.',
    freeCellTutorialStep3: 'Du kan flytta en sekvens om det nedersta kortet är ett steg lägre och i en annan färg än det kort du placerar den på. Kom ihåg: du kan inte flytta fler kort än antalet tomma friceller plus ett.',
    freeCellTutorialStep4: 'Bra! Du kan placera vilket enskilt kort som helst eller en sekvens i en tom kolumn på spelplanen.',
    freeCellTutorialStep5: 'Fria celler är speciella platser för tillfällig förvaring av kort. Varje cell kan hålla ett kort som du kan flytta tillbaka till spelplanen eller grundhögen när det behövs.',
    freeCellTutorialStep6: 'Nu är det din tur! Använd det du lärt dig och avsluta spelet!',

    startTutorialPopupTitle: 'Välkommen! Ta en snabb handledning och lär dig grunderna innan du börjar spela.',
    startTutorial: 'Starta handledningen',
    skipTutorial: 'Hoppa över',
};
